export default "__VITE_ASSET__BYgntqw6__"